// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productBadgesStyles } from "@guestsupply/App/Components/Common/ProductBadges";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { css } from "styled-components";

const sharedBadgeWrapper: InjectableCss = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        gap: 4px;
    `,
};

productBadgesStyles.container = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 8px;
    `,
};

productBadgesStyles.ootbBadgesWrapper = {
    ...sharedBadgeWrapper,
};

productBadgesStyles.customBadgesWrapper = {
    ...sharedBadgeWrapper,
};

productBadgesStyles.badge = {
    tooltipStyles: {
        cssOverrides: {
            tooltipClickable: css`
                margin-left: 0;
                margin-right: 0;
            `,
            tooltipWrapper: css`
                display: flex;
            `,
        },
    },
    imageWrapperStyles: {
        css: css`
            width: 25px;
            height: 25px;
        `,
    },
    imageBadgeProps: {
        width: 25,
        height: 25,
    },
};
